import * as React from "react"
import type { SVGProps } from "react"
const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 19h3v-5q0-.42.29-.71A1 1 0 0 1 10 13h4a.97.97 0 0 1 1 1v5h3v-9l-6-4.5L6 10zm-2 0v-9a2 2 0 0 1 .8-1.6l6-4.5q.53-.4 1.2-.4t1.2.4l6 4.5A2 2 0 0 1 20 10v9q0 .83-.59 1.41A2 2 0 0 1 18 21h-4a1 1 0 0 1-.71-.29A1 1 0 0 1 13 20v-5h-2v5q0 .42-.29.71A1 1 0 0 1 10 21H6q-.82 0-1.41-.59A2 2 0 0 1 4 19" />
  </svg>
)
export default SvgHome
